import React, { useState } from "react";
import { Link } from "react-router-dom";
import { formatNumber, getLink } from "../../utils/helpers";

export default function TopRutas({ rutas }) {
    const [expandRutas, setExpandRutas] = useState(false);

    const maxToneladasRuta = rutas[0] ? rutas[0].toneladas : 0;

    return (
        <div
            className={
                "dashboard-ranking-widget dashboard-top-rutas " +
                (expandRutas ? "expand" : "")
            }>
            <h2 className='dashboard-widget-title'>Rutas con más tons.</h2>
            <ol className='dashboard-ranking'>
                {rutas.map((ruta, index) => (
                    <li
                        title={ruta.descripcion}
                        className='dashboard-ranking-item'
                        key={ruta.nombre}>
                        <span className='dashboard-ranking-index'>
                            {index + 1}.
                        </span>
                        <span className='dashboard-ranking-name'>
                            <Link to={getLink(`/rutas/${ruta.id}`)}>
                                {ruta.nombre} <small>{ruta.descripcion}</small>
                            </Link>
                        </span>
                        <span className='dashboard-ranking-value'>
                            {formatNumber(ruta.toneladas / 1000)}
                        </span>
                        <span
                            className='dashboard-ranking-bar'
                            style={{
                                width:
                                    (100 * ruta.toneladas) / maxToneladasRuta +
                                    "%",
                            }}></span>
                    </li>
                ))}
            </ol>
            <button
                onClick={() => setExpandRutas(!expandRutas)}
                className='show-more-btn'>
                {expandRutas ? "Ver menos" : "Ver más"}
            </button>
        </div>
    );
}
